import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorManagementContentView = () => {
  const contentView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/content/view', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
      loading(false)
    })
  }, [])

  return { contentView }
}

export default InteractorManagementContentView
